import { useEffect, useState } from 'react';
import {
  getStandaloneChargeActivationStatus,
  StandaloneChargeActivationStateEnum
} from '../../../services/standalone-charges';

export const useStandaloneChargeAccountStatus = (estateId: string, enabled: boolean) => {
  const [loading, setLoading] = useState(false);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!enabled || !estateId) {
      setConnected(false);
      return;
    }

    let active = true;
    setLoading(true);
    getStandaloneChargeActivationStatus(estateId)
      .then(status => {
        if (!active) return;
        const activationStatus = status?.activation?.status;
        setConnected(
          activationStatus === StandaloneChargeActivationStateEnum.active ||
            activationStatus === StandaloneChargeActivationStateEnum.pagarmeActive
        );
      })
      .catch(() => active && setConnected(false))
      .finally(() => active && setLoading(false));

    return () => {
      active = false;
    };
  }, [enabled, estateId]);

  return { connected, loading };
};
